export enum SOCIAL_MEDIA {
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  LINKEDIN = 'LinkedIn',
  TWITTER = 'Twitter',
  GOOGLE_PLUS = 'Google+',
  GOOGLE = 'Google'
}
